import { UserRequest } from "../../src/models/UserRequest.js";
import { quotaStatus } from "../services/quotaService.js";
import { getUserIp } from '../services/getUserLocation.js';
import { getUserTimeZone } from '../components/localDateTime';

// apiHelper.js
export const checkUserQuota = async (userEmail, setLoading, setIsModalOpen, apiCalled) => {
    try {
        setLoading(true); // Show spinner while waiting for the response
        const ip = await getUserIp();
        // Create a request object (assuming UserRequest is a class or function that you defined elsewhere)
        const requestData = new UserRequest(userEmail + "," + ip + "," + getUserTimeZone(), "aVo39j49q6w5z8hu5hzuyo36qckf1drq1y!s");

        // Call the backend API
        const apiResponse = await quotaStatus(requestData);

        // Check the response message and trigger modal if needed
        if (apiResponse.data.message === "User account is not allowed") {
            setLoading(false); // Hide spinner before showing modal
            setIsModalOpen(true); // Show the modal popup
        } else {
            setLoading(false); // Hide spinner if quota is allowed
        }
    } catch (error) {
        console.error("Error checking user quota:", error);
        setLoading(false); // Hide spinner in case of error
    }
};
